// siembraOptions.js
export const pistaOptions = {
    avance: [
      { value: 'porTiempo', label: 'Por Tiempos' },
      { value: 'porLugarTiempo', label: 'Por Lugar y Tiempo' },
    ],
    asignacionHeats: [
      { value: 'porMarca', label: 'Por marca de siembra' },
      { value: 'random', label: 'Random' },
      { value: 'seedPrelimsAsTimedFinals', label: 'Seed Prelims as Timed Finals' },
      { value: 'seedTimedFinalsAsPrelims', label: 'Seed Timed Finals as Prelims' },
    ],
    asignacionPosiciones: [
      { value: 'standardLanes', label: 'Standard Lanes' },
      { value: 'customLanes', label: 'Custom Lanes' },
      { value: 'allRandom', label: 'All Random' },
      { value: 'standardAlleys', label: 'Standard Alleys' },
      { value: 'customAlleys', label: 'Custom Alleys' },
      { value: 'waterfallStart', label: 'Waterfall Start' },
    ],
    ordenHeat: [
      { value: 'fastToSlow', label: 'Más rápido al más lento' },
      { value: 'slowToFast', label: 'Más lento al más rápido' },
      { value: 'randomOrder', label: 'Aleatorio' },
    ],
    tipoRondas: [
      { value: 'soloFinales', label: 'Solo Finales' },
      { value: 'prelimFinal', label: 'Preliminares/Final' },
      { value: 'prelimSemiFinal', label: 'Prelim/Semis/Final' },
      { value: 'prelimQtrsSemisFinal', label: 'Prelim/Cuartos/Semis/Final' },
    ],
  };
  
  export const campoOptions = {
    avance: [
      { value: 'mejorMarca', label: 'Por la mejor marca' },
    ],
    asignacionHeats: [
      { value: 'porMarca', label: 'Por marca de siembra' },
      { value: 'random', label: 'Random' },
      { value: 'seedRnd1of2AsFinals', label: 'Seed Rnd 1 of 2 as Finals' },
      { value: 'seedRnd1of1AsPrelims', label: 'Seed Rnd 1 of 1 as Prelims' },
    ],
    asignacionPosiciones: [
      { value: 'mejorPeor', label: 'Mejor a Peor Marca' },
      { value: 'peorMejor', label: 'Peor a Mejor Marca' },
      { value: 'random', label: 'Random' },
      { value: 'alphabetic', label: 'Alfabético' },
      { value: 'numCompetidor', label: '# Competidor' },
    ],
    ordenHeat: [
      { value: 'fastToSlow', label: 'Mejor a Peor' },
      { value: 'slowToFast', label: 'Peor a Mejor' },
      { value: 'randomOrder', label: 'Aleatorio' },
    ],
    tipoRondas: [
      { value: 'soloFinales', label: 'Solo Finales' },
      { value: 'prelimFinal', label: 'Prelim/Final' },
      { value: 'prelimSemiFinal', label: 'Prelim/Semis/Final' },
      { value: 'prelimQtrsSemisFinal', label: 'Prelim/Cuartos/Semis/Final' },
    ],
  };
  
  export function getDefaultConfig(isFieldEvent) {
    if (isFieldEvent) {
      // Para campo
      return {
        avance: 'mejorMarca',
        asignacionHeats: 'porMarca',
        asignacionPosiciones: 'mejorPeor',
        ordenHeat: 'fastToSlow',
        tipoRondas: 'soloFinales',
      };
    } else {
      // Para pista
      return {
        avance: 'porTiempo',
        asignacionHeats: 'porMarca',
        asignacionPosiciones: 'standardLanes',
        ordenHeat: 'fastToSlow',
        tipoRondas: 'soloFinales',
      };
    }
  }
  